import http from 'plugins/axios';

export default {


  //获取商家申请记录列表
  getMerchantRecordList(data) {
    return http.get({
      url: `/admin/otc/getMerchantRecordList`,
      data: data
    });
  },
  //商家详情
  getMerchantDetail(id) {
    return http.get({
      url: `/admin/otc/getMerchantDetail`,
      data: {
        id: id
      }
    });
  },

  //收款人详情
  getPayeeDetail(id) {
    return http.get({
      url: `/admin/otc/getPayeeDetail`,
      data: {
        id: id
      }
    });
  },

  //商家申请信息审核
  auditMerchant(data) {
    return http.post({
      url: `/admin/otc/auditMerchant`,
      data: data,
      dataType: 'form'
    });
  },

  quitMerchant(data) {
    return http.post({
      url: '/admin/otc/quitMerchant',
      data,
      dataType: 'form'
    })
  },



  ///////////波 end///////////////
  //收款人审核列表
  getOtcPayeeList(data) {
    return http.get({
      url: `/admin/otc/getOtcPayeeList`,
      data: data
    });
  },
  //收款人审核
  auditPayee(data) {
    return http.post({
      url: `/admin/otc/auditPayee`,
      data: data,
      dataType: 'form'
    });
  },


  //商户升级列表
  getUpgradeList(data) {
    return http.get({
      url: `/admin/otc/getUpgradeList`,
      data: data
    });
  },
  //商户升级审核
  auditUpgrade(data) {
    return http.post({
      url: `/admin/otc/auditUpgrade`,
      data: data,
      dataType: 'form'
    });
  },


  //////小波接口//////////
  //  订单列表
  getOrderList(data) {
    return http.get({
      url: `/admin/otcOrder/list`,
      data: data
    });
  },

    //冻结列表
    getotcFrozenList(data) {
    return http.get({
      url: `/admin/otcFrozen/list`,
      data: data
    });
  },

  //订单审核
  orderApprove(data) {
    return http.post({
      url: `/admin/otcOrder/approve`,
      data: data,
      dataType: 'form'
    });
  },


  allege(data, toFrom) {
    let url = '';
    if (toFrom == 1) {
      url = '/admin/otcOrder/allege';  //订单设置为申诉状态
    } else {
      url = '/admin/otcOrder/cancelAllege';//订单取消申诉状态
    }
    return http.post({
      url: url,
      data: data,
      dataType: 'form'
    });
  },

  cancelFinish(data, toFrom) {
    let url = '';
    if (toFrom == 1) {
      url = '/admin/otcOrder/cancelOrder';  //直接取消订单
    } else {
      url = '/admin/otcOrder/finishOrder';//直接已完成订单
    }
    return http.post({
      url: url,
      data: data,
      dataType: 'form'
    });
  },





  //广告审核列表
  advertising(data) {
    console.log("广告的apis:", data)
    return http.get({
      url: `/admin/advertising/list`,
      data: data,
    });
  },

  //广告审核 
  advertisingApprove(data) {
    return http.post({
      url: `/admin/advertising/approve`,
      data: data,
      dataType: 'form'
    });
  },

  //强制下架
  advertisingSoldOut (data) {
    return http.post({
      url: `/admin/advertising/soldOut`,
      data: data,
      dataType: 'form'
    });
  },

  //申诉列表
  getAllegeList(data) {
    return http.get({
      url: `/admin/otcAllege/list`,
      data: data
    });
  },

    //申诉明细
    getAllegeDetailInfo(id) {
      return http.get({
        url: `/admin/otcAllege/info`,
        data: {
          id: id
        }
      });
    },
  
    
  //申诉材料审核
  allegeAuditFiles(data) {
    return http.post({
      url: `/admin/otcAllege/auditFiles`,
      data: data,
      dataType: 'form'
    });
  },

    //申诉审核判定
    isAuditAllege(data) {
      return http.post({
        url: `/admin/otcAllege/auditAllege`,
        data: data,
        dataType: 'form'
      });
    },


      //提交冻结信息
  otcFrozen(data) {
    return http.post({
      url: `/admin/otcFrozen/frozen`,
      data: data,
      dataType: 'form'
    });
  },
  unfrozen(data) {
    return http.post({
      url: `/admin/otcFrozen/unfrozen`,
      data: data,
      dataType: 'form'
    });
  },

    getMerchantList(data) {
        return http.get({
            url: `/admin/otc/getMerchantList`,
            data
        });
    },

    updateMerchantContact(data) {
        return http.post({
            url: `/admin/otc/updateMerchantContact`,
            data,
            dataType: 'form'
        });
    },
}